import BlogCard from 'js/blog/components/Card'
import NewsCard from 'js/news/components/Card'
import QuestionCard from 'js/questions/components/Card'

type Entity = {
    __typename: string
    [key: string]: any
}

type Props = {
    entity: Entity
    [key: string]: any
}

const Card = (props: Props) => {
    const { entity } = props

    switch (entity.__typename) {
        case 'News':
            return <NewsCard entity={entity} {...(props as any)} />

        case 'Blog':
            return <BlogCard entity={entity} {...(props as any)} />

        case 'Question':
            return <QuestionCard entity={entity} {...(props as any)} />

        default:
            console.error('Unknown entity: ', entity)
            return null
    }
}

export default Card
